import Link from './ui-component';

export default Link;
